import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chipsSelectorOptionClasses',
  standalone: false,
})
export class ChipsSelectorOptionClassesPipe<T> implements PipeTransform {
  transform(
    item: T,
    angularIcon: { values?: any[]; class?: string } | null | undefined,
    isMessageOption: boolean,
  ): string[] {
    const classes: string[] = [];

    if (
      angularIcon?.class
      && Array.isArray(angularIcon.values)
      && angularIcon.values.includes(item as any)
    ) {
      classes.push(angularIcon.class);
    }

    if (isMessageOption) {
      classes.push('chips-selector-message-option');
    }

    return classes;
  }
}

